import { DEFAULTS, World } from '@metavrse-inc/metavrse-lib';
import { atomWithReset } from 'jotai/utils';

export const worldAtom = atomWithReset<World>(DEFAULTS.worldDefaults);
